export const tr = {
    'compact-title': 'Toplam'
};
